module.exports = __webpack_public_path__ + "static/media/ruby.080968f3.jpg";